import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IconTypes } from '@shared/v2/models';
import { SdvorIconComponent } from '../icon';
import { TabBarActiveItem } from './tab-bar-active-item.const';
import { TabBarActiveItemService } from './tab-bar-item.service';

@Component({
  selector: 'sd-tab-bar-item',
  templateUrl: './tab-bar-item.component.html',
  styleUrls: ['./tab-bar-item.component.scss'],
  imports: [SdvorIconComponent, NgIf],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdvorTabBarItemComponent implements OnInit {
  @Input() icon: IconTypes;
  @Input() label: string;
  @Input() badgeCount: number;
  @Input({ required: true }) contextItem: TabBarActiveItem;

  @HostBinding('class')
  get classes(): Record<string, boolean> {
    return {
      tab: true,
      tab_active: this.isActive,
      'tab_with-label': !!this.label,
    };
  }

  isActive = false;

  constructor(
    private tabBarActiveItemService: TabBarActiveItemService,
    private destroyRef: DestroyRef,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.tabBarActiveItemService
      .getActiveItem()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((activeItem) => {
        this.isActive = activeItem === this.contextItem;
        this.cdr.markForCheck();
      });
  }
}
